import { axiosClient } from '../../clients/axios-client'
import type { Prompt, ReviewMode } from '../../types'
import { buildCreatePromptReviewFields } from '../../types/review-mode'
import { normalizePromptTitle } from '../../utils/prompt-title'
import type { CreatePromptResponseDto } from './dtos/prompt'
import { CreatePromptResponseDtoSchema } from './dtos/prompt'
import { mapPrompt } from './prompt-mapper'

export interface CreatePromptParams {
  userPrompt: string
  llmModel: string
  title?: string
  systemPrompt?: string
  reviewMode?: ReviewMode | null
  signal?: AbortSignal
}

export async function createPrompt({
  userPrompt,
  llmModel,
  title,
  systemPrompt,
  reviewMode,
  signal,
}: CreatePromptParams): Promise<Prompt> {
  const normalizedTitle = normalizePromptTitle(title)

  const payload = {
    user_prompt: userPrompt,
    llm_model: llmModel,
    ...(normalizedTitle ? { title: normalizedTitle } : {}),
    ...(systemPrompt ? { system_prompt: systemPrompt } : {}),
    ...buildCreatePromptReviewFields(reviewMode),
  }

  try {
    const { data } = await axiosClient.post<CreatePromptResponseDto>('/prompts', payload, {
      signal,
    })

    const { prompt, message } = CreatePromptResponseDtoSchema.parse(data)
    if (!prompt) {
      throw new Error(`Create prompt failed: ${message}`)
    }

    return mapPrompt(prompt)
  } catch (error) {
    console.error('Create prompt failed', error)
    throw error
  }
}
